<script lang="ts">
    import type { InstachatState, Role, ShowcaseTexts } from "./instachat";
    import { state } from "./stores";

    export let texts: ShowcaseTexts;

    $: text = $state === "OPEN" ? texts.open : texts.closed;
</script>

{@html text}
